import React, { Component} from 'react';
import { FacebookProvider, Like } from 'react-facebook';

export default class FbLike extends Component {
  render() {
    return (
      <FacebookProvider appId="2736511256363790">
        <Like href="https://www.facebook.com/StartupItalia.eu/" colorScheme="dark" showFaces="false" size="large" share="false" layout="button"/>
      </FacebookProvider>
    );
  }
}

/*FB.login(function(response) {
        if (response.status == 'connected') {
            var user_id = response.authResponse.userID;
            var page_id = "40796308305"; // coca cola page https://www.facebook.com/cocacola
            var fql_query = "SELECT uid FROM page_fan WHERE page_id="+page_id+" and uid="+user_id;

            FB.api({
                method: 'fql.query',
                query: fql_query
            },
            function(response){
                if (response[0]) {
                    $("#container_like").show();
                } else {
                    $("#container_notlike").show();
                }
            }
            );
        } else {
        // user is not logged in
        }
    });

*/
